import { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';
import { SnackbarActionType } from '../context/snackbar/actions';
import { useSnackbarContext } from '../context/snackbar/context';
import { intl } from '../helpers/IntGlobalProvider';
import { useDriversState } from '../hooks/useDriversState';
import { PRIVATE_COMPONENT_ID } from '../pages/app/PrivateComponent';
import { MobileRoutalSnackbar } from '../react-components/MobileRoutalSnackbar';
import { Text } from '../react-components/Text';

export const SnackbarComponent = () => {
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const { snackbarState, snackbarDispatch } = useSnackbarContext();
  const { type, autoHideDuration, message, onClick } = snackbarState;
  const { driversState } = useDriversState();
  const { height, width, offsetTop, offsetLeft } = driversState;

  useEffect(() => {
    setOpenSnack(!!message);
  }, [message]);

  const onClose = () => {
    snackbarDispatch({ type: SnackbarActionType.SNACKBAR_CLOSE });
  };

  const paddingLeft = 20;
  const paddingRight = 20;
  const paddingBottom = 20;

  const isMessageAString = typeof message === `string`;

  const content = (
    <MobileRoutalSnackbar
      variant={type}
      open={openSnack && !!message}
      onClose={onClose}
      onClick={onClick}
      autoHideDuration={autoHideDuration}
      showCloseButton
      containerStyle={{
        bottom: window.innerHeight - (height + offsetTop) + paddingBottom,
        left: offsetLeft + paddingLeft,
        width: width - 38 - paddingLeft - paddingRight,
        zIndex: 50000,
        maxWidth: `unset`,
      }}
    >
      {message &&
        (isMessageAString ? <Text>{intl.formatMessage({ id: message, defaultMessage: message })}</Text> : message)}
    </MobileRoutalSnackbar>
  );
  const element = document.getElementById(PRIVATE_COMPONENT_ID ?? ``);
  if (element) {
    return createPortal(content, element as HTMLElement);
  }

  return content;
};
